import { JwtService } from './jwt.service';

import { of as observableOf, Observable, from } from 'rxjs';

import { map, catchError, tap, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { LoadSpinnerService } from './load-spinner.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileContentService {
  constructor(private http: HttpClient, private loader: LoadSpinnerService) {}

  loadFileContent(url: string = ''): Observable<string> {
    this.loader.showSpinner();

    const headers = new HttpHeaders({
      ignore: 'true',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers':
        'Origin, Content-Type, Access-Control-Allow-Headers, Authorization, ApiKey, X-Requested-With'
    });

    return this.http
      .get(url, {
        responseType: 'blob',
        headers: headers
      })
      .pipe(
        take(1),
        switchMap((response) => {
          return from(
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsDataURL(response);
            })
          );
        }),
        tap((value) => {
          this.loader.hideSpinner();
        }),
        catchError((err) => {
          this.loader.hideSpinner();
          return observableOf(err);
        })
      );
  }
}
